import { PAGE_TYPE_ENUM } from "@shared/types";
import NewsletterSignup from "components/blog/blog-post/NewsletterSignup";
import BlogPageContent from "components/blog/BlogPageContent";
import { DatoComponentsWrapper } from "components/common/DatoComonentsWrappeer/DatoComponentsWrapper";
import PageLayout from "components/layout/PageLayout";
import { setDYContext } from "config";
import { useLogContext } from "context/log";
import { generatePageId } from "helpers/analyticsLogger";
import { setCachingHeader } from "helpers/cacheHeader";
import { GetServerSideProps } from "next";
import { useEffect } from "react";
import { createDatoClient } from "services/datocms";
import {
  AllBlogSectionsQuery,
  BlogPageQuery,
  getSdk,
} from "services/datocms/generated";
import { createQueryParamsForCaching } from "utils/create-query-params";

type BlogPageProps = {
  pageData?: BlogPageQuery["blogPage"] | null;
  sections: AllBlogSectionsQuery["allBlogSections"];
};

export const getServerSideProps: GetServerSideProps<BlogPageProps> = async (
  context,
) => {
  setCachingHeader(context);
  try {
    const [{ allBlogSections }, { blogPage }] = await Promise.all([
      getSdk(
        createDatoClient(
          context.preview,
          createQueryParamsForCaching({ queryType: "AllBlogSections" }),
        ),
      ).AllBlogSections(),
      getSdk(
        createDatoClient(
          context.preview,
          createQueryParamsForCaching({ queryType: "BlogPage" }),
        ),
      ).BlogPage(),
    ]);
    return {
      props: {
        sections: allBlogSections ?? [],
        pageData: blogPage,
      },
    };
  } catch (error) {
    return {
      props: {
        pageData: null,
        sections: [],
      },
    };
  }
};

const BlogHomepage: React.FC<BlogPageProps> = ({ sections, pageData }) => {
  const { useLogPageView } = useLogContext();

  useLogPageView({
    pageType: PAGE_TYPE_ENUM.blog,
    id: generatePageId("blog homepage"),
  });

  useEffect(() => {
    setDYContext("OTHER", ["Blog"]);
  }, []);

  return (
    <PageLayout navigationOverlapsContent seo={pageData?.seo}>
      {pageData && (
        <>
          <BlogPageContent sections={sections} pageData={pageData} />
          <NewsletterSignup newsletterData={pageData.bodyNewsletter} />
          <DatoComponentsWrapper components={pageData.components} />
        </>
      )}
    </PageLayout>
  );
};

export default BlogHomepage;
